import PropTypes from 'prop-types';
import React from 'react';

import { withFormikField, getFormikError } from 'utils/formik';

import { StyledSelect } from './styled';
import { injectIntl } from 'react-intl';

const ShipperUserSelector = ({ field, form, disabled, onChange, shipperUsers, intl, ...props }) => {
  const t = intl.messages.modules.chooseUser;
  const { name, value } = field;
  const { setFieldValue } = form;
  return (
    <StyledSelect
      {...props}
      placeholder={t.placeholder}
      ignoreCase={true}
      matchPos="any"
      clearable={false}
      small
      noResultsText={t.no_content}
      value={value}
      options={shipperUsers}
      onChange={(user) => {
        setFieldValue(name, user);
        onChange(user);
      }}
      valueKey="url"
      labelKey="name"
      disabled={disabled}
      invalid={
        !!getFormikError({ field, form }) ||
        !!getFormikError({ field: { name: `${name}_id` }, form })
      }
      width={360}
    />
  );
};

ShipperUserSelector.propTypes = {
  field: PropTypes.object,
  form: PropTypes.object,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  shipperUsers: PropTypes.array,
};

ShipperUserSelector.defaultProps = {
  shipperUsers: [],
};

export default withFormikField(injectIntl(ShipperUserSelector));
